/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:31:10
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "ናይ መሳርሒ ሞዴል ምረፅ",
    name2: "ዝተሰሓሓተ ገለፃ",
    name3: "ናይ ግልጋሎት መኽዘን ንምምራፅ ንኻእ",
    name4: "ናይ ግልጋሎት መኽዘን፡",
    name5: "ቦታ ዝተትሓዘሉ ግዜ፡",
    name6: "በይዞም ናይ መሳርሒኦም ፀገም ብዝርዝ ይመዝግቡ!",
    name7: "ናይ ዝበፅሐሉ ግዜ ንምምራፅ ንኻእ",
    name8: "በይዘኦም ትኽክለኛ ኣድራሽኦም የእትዉ ስለዝኾነ ክንረኽቦም ንኽእል ኢና",
    name9: "ዝርከቡ ቦታ ናይ ምትሓዝ እዋን ዝስዕቡ እዮም",
    name10: "በይዘኦም ስልኪ ቑፅሮም የእትዉ",
    name11: "ዋጋ",
    name12: "ናይ ዉልቀ ሓበሬታ፡",
    name13: "በይዘኦም ሽሞም የእትዉ",
    name14: "ኣእትዉ",
    name15: "ሰርዝ",
    name16: "ሕራይ",
  },
  shops: {
    name1: "ብዝመረፅካዮ ብራንድ ብምምስራት፣ እቶም ዝስዕቡ መደብራት ከገልግሉኻ እዮም!",
    name2: "ተወሰኽቲ ናይ ሸቐጥ መኽዘናት ኣብ ቐረባ እዋን! ምሳና ይፅንሑ!",
  },
  price: {
    name1: "ብራንድ",
    name2: "ሞዴል",
    name3: "ነገር",
    name4: "ዋጋ",
    name5: "ምሕዝነታዊ መዘኻኸሪ፡",
    name6: "እቶም ዋጋ ንመጣቐሲ እዮም፣ ስለዝኾነ እቲ ትኽክለኛ ዋጋ በቲ ናይ መሳርሒኻ ብልሽት ኹነት ይዉነን",
    name7: "ፍሉይ ምልክት ተዘይሃልዩዎ፣ እቲ ናይ ዋጋ ክፍሊ ናይ ከባቢ ሸርፊ ክፍሊ እዩ",
    name8: "ይቕረታ! ኣብቲ ናይ ሕጂ ክልል ምንም ናይ  ዋጋ ሓበሬታ የለን",
    name11:"ወፃኢታት ጉልበት",
    name12:"ጠቕላላ ዋጋ",
    name13: "5. ወፃኢ ጉልበት \"/\" እንተኾይኑ፣ ወፃኢ ጉልበት ምስቲ ድንኳን ምምኽኻር የድሊ ማለት እዩ፡፡",
    item_main_board: "ዋና ቦርድ",
    item_screen_frame: "ስክሪን (ፍሬም)",
    item_screen_screen_frame: "ካልኣዊ ስክሪን (ፍሬም)",
    item_touch_screen: "ታች ስክሪን",
    item_camera: "ካሜራ",
    item_fixed_focus_camera: "ቀዋሚ ትኹረት ካሜራ",
    item_auto_focus_camera: "አውቶማቲክ ትኹረት ካሜራ",
    item_screen: "ስክሪን",
    item_secondary_screen: "ካልኣይ ስክሪን",
    item_fingerprint_module: "ናይ ኣፃብዕቲ ዓሸራ ሞዱል",
    item_speaker: "መጋዉሒ ድምፂ",
    item_receiver: "ተቐባሊ",
    item_small_board: "ንእሽቶይ ቦርድ",
    item_battery_cover: "ሽፋን ባትሪ",
    item_battery: "ባትሪ",
    item_charger: "ቻርጀር",
    item_usb_cable: "ናይ USB ገመድ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ዳታ የለን",
    name2: "ግልጋሎት መቕረቢ፡",
    name3: "ናይ ግልጋሎት ብራንድ፡",
    name4: "ቴሌፎን፡",
    name5: "ናይ ትእዛዝ በዝሒ፡",
    name6: "ናይ ግልጋሎት ምድብ",
    name7: "ናይ ግልጋሎት ከባቢ፡",
    name8: "ናይ ግልጋሎት ኹነት፡",
    name9: "ናይ ግልጋሎት ቕልጥፍና፡",
    name10: "ናይ ግልጋሎት ፅፈት፡",
    name11: "ናይ ዓሚል ገምጋም",
    name12:"ናብ",
    name13:"ተዓፅዩ",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ኽፈት",
    name1: "በይዘኦም እቲ ናይ ምሓዝ ሓበሬታ ስክሪንሹት የልዕሉ ከምኡዉን ናይ ቐዳምነት ግልጋሎት ንምርካብ ከም ቅብሊት የቐምጥዎ",
    name2: "ብዕዉት ኣትዩ",
    name3: "1. ዳታ ኣፅሪ",
    name4: "በይዘኦም ኣብ ስልኮም ዘሎ ጠቓሚ ናይ ዉልቀ ዳታ ኣቐዲሞም መሐለዉታ ይግበሩ",
    name5: "2. እቲ ናይ ሓይሊ ምብራህ መሕለፊ ቃል ንከይሰርሕ ይግበሩ",
    name6: "ቕድሚ ናይ ናይ ግልጋሎት መኽዘን ምኻዶም፣ በይዘኦም፡",
    name7: "ናይ ግልጋሎት መኽዘን፡",
    name8: "ቦታ ዝተትሓዘሉ ግዜ፡",
    name9: "ዝተሰሓሓተ ገለፃ",
    name10: "ናይ መሳርሒ ሞዴል፡",
    name11: "ናይ ትእዛዝ ቑፅሪ፡",
    name12: "ናይ ትእዛዝ ሓበሬታ",
  },
  title: {
    
    name1: "ዝስዕቡ ሃገራት ይድገፉ፡",
    name2: "ሞዴል ምረፅ",
    name3: "ቦታ ምሓዝ",
    name4: "ናይ ግልጋሎት መኽዘን ዝርዝራት",
    name5: "ናይ ግልጋሎት መኽዘን ምረፅ",
  },
  error: {
    
    name1: "ዳታ የለን፡፡ በይዘኦም ነቲ ናይ ፅገና ሓበሬታ የረጋግፁ",
    name2: "ተወሳኺ ሓገዘዝ ደልዩ ድዮም? በይዘኦም ይርከቡና",
    name3: "ይቕረታ! ኣብቲ ናይ ሕጂ ክልል ናይ  Carlcare ምእኸል የለን",
    name4: "በይዘኦም መጀመርታ ናይ ግልጋሎት ማእኸል ይምረፁ",
    name5: "ፈሺሉ",
    name6: "በይዘኦም መጀመርታ ናይ መሳርሒ ሞዴል ይምረፁ",
    name7: "ዝርዝራት",
    name8: "በይዘኦም ድልየቶም ብዝርዝ ይግለፁ",
    name9: "",
  },
  add1:{
    "name0": "ti-rET",
    "name1": "ትእዛዝኩም ተረጋጊፁ ኣሎ፡፡ ምምፃእኹም ብሃንቀውታ ንፅበ።",
    "name2": "ከተማ ምረፅ",
    "name3": "በይዘኦም ስልኪ ቑፅሪ %1$s ኣሃዛት የእትዉ፡፡",
    "name4": "ናይ ሰሙን መዓልቲ ሰዓታት",
    "name5": "ሰኑይ",
    "name6": "ሰሉስ",
    "name7": "ረቡዕ",
    "name8": "ሓሙስ",
    "name9": "ዓርቢ",
    "name10": "ቐዳም",
    "name11": "ሰንበት",
    "name12": "ሃገር ኣእቲኻ ድለ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ኻልኦት",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ናብ ኣንፈት ምቕያር ዝብል ጠውቕ",
    name3:"ነቲ ትእዛዝ ደረጃ ንምሃብ ነቲ Carlcare ዓውደሞያ ኽፈት",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ግልጋሎት ምረፅ",
    name7:"ነፃ ምፅራይ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ትኽክል ዘይኮነ ሓበሬታ",
    "cancelReason1": "ብሰዓቱ ኣይበፅሐን",
    "cancelReason2": "ዝተደገመ ትእዛዝ/ናተይ ትእዛዝ ኣይኮነን",
    "cancelReason3": "ፍሽለት ኣይተደገመን",
    "cancelReason4": "ንፈተነ ጥራይ/ሕተት/ኽስተት/…",
    "cancelReason5": "ዝለዓለ ዋጋ",
    "cancelReason6": "ናይ ኣቕሓ ሕፅረት",
    "cancelReason7": "ምንም ዝተፈለየ ግልጋሎት የለን",
    "cancelReason8": "እቲ መኽዘን ኣዝዩ ርሑቕ",
    "cancelReason9": "እቲ መኽዘን ተዓፅዩ",
    "cancelReason10": "ሕማቕ ግልጋሎት ኣመለኻኽታ",
    "cancelReason11": "ንኻልኦት ብራንዳትምትካእ/ኣዐሪ",
    "cancelReason12": "ነቲ መኽዘን ምርካብ ኣይተኽኣለን",
    "cancelReason13": "ኻሊእ",
    "cancelOrder": "ትእዛዝ ሰርዝ",
    "reason_dialog_title": "በይዘኦም ናይ ዝተሰረዘሉ ምኽንያት ይንገሩና",
    "Cancel": "ይሰርዙ",
    "OK": "ሕራይ",
    "name1": "ናይ መረጋገፂ ኮድ የእትዉ",
    "name2": "ተቐባልነት ዘይብሉ ናይ መረጋገፂ ኮድ",
    "repair_reservation_detail_canceled": "እዚ ትእዛዝ ተሰሪዙ!",
    "purchase_cancel_dialog_content": "ነቲ ትእዛዝ ክትስርዞ ተረጋገፅ ዲኻ?",
    "yes": "እወ",
    "no": "ኣይኮነን"
}
};
